import React from "react";
import styles from "./AddButton.module.scss";
import classNames from "classnames";

import { ReactComponent as Plus } from "../../assets/icons/plus.svg";

const AddButton = ({ title, onClick, className, style, disabled }) => {
  return (
    <button
      disabled={disabled}
      style={style}
      className={classNames(
        styles.buttonContainer,
        className,
        disabled && styles.disabled
      )}
      onClick={onClick}
    >
      <Plus />
      {title}
    </button>
  );
};

export default AddButton;
